module.exports = __webpack_public_path__ + "static/media/Fondo.c08cad9b.png";